

<header class="jjsv-header">
    <div class="jjsv-header__logo">
        <img src="/assets/svgs/logo.svg" alt="J&amp;J logo" />
    </div>
    <nav class="jjsv-header__nav" aria-label="User navigation">
        @let nodes = (navNodes$ | async);
        @if (nodes?.link && nodes.link.length > 0) {
            <div class="jjsv-header__links" aria-label="Navigation nodes">
                @for (node of nodes.link; track node.id) {
                    <a
                        class="jjsv-header__link"
                        [routerLink]="node.path"
                        (click)="onNavLinkClick(node.path)"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        aria-label="{{ node.label }}"
                    >
                        {{ node.label }}
                    </a>
                }
            </div>
        }
        <div class="jjsv-header__actions">
            @if (nodes?.loginStatus) {
                <button
                    type="button"
                    class="jjsv-header__logout"
                    (click)="onLogout()"
                    aria-label="Logout"
                    [attr.aria-expanded]="showLogoutPopover"
                >
                    <img src="/assets/svgs/Shape.svg" alt="" aria-hidden="true" height="20" width="20" />
                    <img class="verified_icon" src="/assets/svgs/Verified.svg" alt="" aria-hidden="true" />
                </button>

                @if (showLogoutPopover) {
                    <div class="jjsv-header__logout-popover" role="dialog" aria-label="Logout confirmation">
                        <div class="jjsv-header__logout-popover-header">
                            <button
                                type="button"
                                class="jjsv-header__logout-close"
                                (click)="closeLogoutPopover()"
                                aria-label="Close logout popup"
                            >
                                <img src="/assets/svgs/Close.svg" alt="" height="20" width="20"/>
                            </button>
                            

                            <div class="jjsv-header__logout-status" aria-hidden="true">
                                <img src="/assets/svgs/Shape-popup.svg" alt="" height="20" width="20"/>
                                <img class="verified_icon verified_icon--popover" src="/assets/svgs/Verifid-popup.svg" alt="" height="20" width="20"/>
                            </div>
                        </div>

                        <div class="jjsv-header__logout-divider"></div>

                        <button type="button" class="jjsv-header__logout-action" (click)="confirmLogout()">
                            Log Out
                        </button>
                    </div>
                }
            } @else {
                <img src="/assets/svgs/Account.svg" alt="Account" />
            }
        </div>
    </nav>
    @if (nodes?.subNavLinks && nodes.subNavLinks.length > 0) {
        <div class="navigation-tab">
        <a [routerLink]="['/homepage']"> <img src="/assets/svgs/Home.svg" alt="Home" height="20" width="20" /> </a>
        <span class="navigation-tab__separator"><img src="/assets/svgs/Arrow.svg" alt="Arrow" /></span>
        <span class="navigation-tab__current"> {{ nodes.subNavLinks[0]?.label }}</span>
    </div>
    }
</header>